import { useSnackbar } from 'notistack'
import { useCallback, useState } from 'react'
import { CarePartnerCreateDTO, CarePartnerPublicResponseDTO, CarePartnerResponseDTO, CarePartnersService } from '../client'

export const useCreateCarePartner = () => {
    const [carePartner, setCarePartner] = useState<CarePartnerResponseDTO | CarePartnerPublicResponseDTO | null>(null)
    const [loading, setLoading] = useState<boolean>(false)
    const [error, setError] = useState<string | null>(null)
    const { enqueueSnackbar } = useSnackbar()

    const createCarePartner = useCallback(
        async (carePartnerData: CarePartnerCreateDTO) => {
            setLoading(true)
            setError(null)
            try {
                const response = await CarePartnersService.createCarePartnerCarePartnersPost({
                    requestBody: carePartnerData
                })
                setCarePartner(response)
                enqueueSnackbar('Care partner created successfully', { variant: 'success' })
                return response
            } catch (err) {
                const errorMessage = err instanceof Error ? err.message : 'Failed to create care partner'
                setError(errorMessage)
                enqueueSnackbar(errorMessage, { variant: 'error' })
                throw err
            } finally {
                setLoading(false)
            }
        },
        [enqueueSnackbar]
    )

    return { carePartner, loading, error, createCarePartner }
}
